import React from 'react';

import { logger as LOG } from '@garnish/logger';
import { useActor } from '@xstate/react';

import { useEssentialMachines } from '../../EssentialMachines';
import { AuthModel } from '../AuthMachine.model';

// ────────────────────────────────────────────────────────────────────────────────
// LOG.enable('AUTH');
const logger = LOG.extend('AUTH');
// ────────────────────────────────────────────────────────────────────────────────

export const useSendLoginToAuthMachine = () => {
  const { authMachineRef } = useEssentialMachines();
  const authMachine = useActor(authMachineRef);
  const { 1: send } = authMachine;

  const sendLoginAction = React.useCallback(
    (params?: SendLoginActionParams) => {
      logger.debug('sending LOGIN event to AuthMachine');
      send(AuthModel.events.LOGIN(params?.csrf, params?.postLoginRedirectHref));
    },
    [send],
  );

  return sendLoginAction;
};

// ─── Types ───────────────────────────────────────────────────────────────────

type SendLoginActionParams = {
  csrf?: string;
  postLoginRedirectHref?: string;
};
